









































import Page from '@/Page.vue';
import { Component, Prop, PropSync, Ref, VModel, Watch } from 'vue-property-decorator';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Guid } from '@/libs/common/functions/guid';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { ApplicationUserModel, PartyWorkDayModel, WorkTaskModel } from '@/libs/Api';
import { partyWorkDaysStore } from '@/libs/party-work-days/+state/store';
import { useObjectKey } from '@/libs/common/functions/use-object-key';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';
import { cloneDeep } from 'lodash';

@Component({
    components: {
    }
})
export default class WorkTaskCloseDialog extends Page {

    /* Component props */
    @VModel() dialog!: boolean;
    @Prop() item!: PartyWorkDayModel | null;
    @Prop() workTasks!: WorkTaskModel[];

    /* Component state variables */
    valid = true;
    saving = false;
    hasChanges = true;
    createPlanItem = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;

	get sortedWorkTask(): WorkTaskModel[] {
		console.log(this.workTasks.orderBy(x => x.catalogueItem!.name).toArray());
		return this.workTasks.orderBy(x => x.catalogueItem!.name).toArray();
	}

    @Ref() form!: any;
    
    /* Action functions */
    
    closeDialog () {
        this.$emit("input", false);
        this.$emit("close");
        this.dialog = false;
    }
    
    markIsDone () {
        this.saving = true;
        const partyWorkDay = cloneDeep(this.item);
        partyWorkDay!.isDone = true;
        partyWorkDaysStore.dispatch(CrudAction.Update, { item: partyWorkDay });
        this.subscribe(partyWorkDaysStore, CrudReponse.Update).then(() => {
            this.saving = false;
            this.$emit("markDone", true);
        }).catch((e) => {
            this.saving = false;
            this.$emit("markDone", partyWorkDay!.isDone!);
            this.$emit("error");
            console.log(e);
        })
    }

    getUnitShortName (v: string) {
        return this.$i18n.t("codebooks." + v);
    }

}
